export const toArray = (arr?: string, separator = ',') =>
  arr?.split(separator) || [];

export const toArrayNumber = (arr?: string, separator = ',') =>
  toArray(arr, separator).map(x => +x);
